(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shark-lp-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  const selector = '.tlo[data-shark-offer]';
  const mounted = new WeakMap();
const initializeSpotlight = (root) => {
  const panel = root.querySelector('[data-tlo-spotlight]');
  const timers = root.querySelectorAll('[data-tlo-spotlight-timer]');
  const copy = panel?.querySelector('[data-tlo-spotlight-copy]');
  if (!panel || !timers.length || !copy) return () => {};
  const duration = 60 * 60 * 1000;
  const key = 'sopami:offer-spotlight:v2:' + root.dataset.productHandle;
  const messages = [panel.dataset.spotlightFirst, panel.dataset.spotlightSecond];
  let state;
  try { state = JSON.parse(localStorage.getItem(key)); } catch (_) {}
  const now = Date.now();
  if (!state || !Number.isFinite(state.endsAt) || state.endsAt > now + duration || !Number.isInteger(state.index) || state.index < 0 || state.index >= messages.length) {
    state = {endsAt: now + duration, index: 0};
  }
  const persist = () => { try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {} };
  const tick = () => {
    const current = Date.now();
    if (current >= state.endsAt) {
      const elapsed = Math.floor((current - state.endsAt) / duration) + 1;
      state.index = (state.index + elapsed) % messages.length;
      state.endsAt += elapsed * duration;
      persist();
    }
    const remaining = Math.max(0, Math.ceil((state.endsAt - current) / 1000));
    const digits = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60].map(value => String(value).padStart(2, '0')).join(':');
    timers.forEach(timer => { if (timer.textContent !== digits) timer.textContent = digits; });
    if (copy.textContent !== messages[state.index]) copy.textContent = messages[state.index];
  };
  persist();
  tick();
  panel.hidden = false;
  const interval = setInterval(tick, 1000);
  return () => clearInterval(interval);
};


  // Shark mop reviews: the first page is the six review blocks rendered by Liquid; further pages come from
  // the product's imported TikTok Shop data rendered inline by snippets/sopami-shark-reviews.liquid.
  const initializeReviewBrowser = (root, listen, isDisposed) => {
    const browser = root.querySelector('[data-tlo-review-browser]');
    const grid = browser?.querySelector('[data-tlo-review-grid]');
    const controls = browser?.querySelector('[data-tlo-review-controls]');
    const previous = browser?.querySelector('[data-tlo-review-previous]');
    const next = browser?.querySelector('[data-tlo-review-next]');
    const status = browser?.querySelector('[data-tlo-review-status]');
    const range = browser?.querySelector('[data-tlo-review-range]');
    const dataEl = browser?.querySelector('[data-shark-review-source] [data-slo-review-data]');
    if (!grid || !controls || !previous || !next || !status || !range || !dataEl) return () => {};
    const validReview = (review) => review && Number.isInteger(review.rating) && review.rating >= 4 && review.rating <= 5 &&
      typeof review.author === 'string' && review.author.trim() && review.author.length <= 100 &&
      typeof review.body === 'string' && review.body.length <= 5000 &&
      typeof review.variant === 'string' && review.variant.length <= 500 &&
      typeof review.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(review.date);
    let source = [];
    try { source = JSON.parse(dataEl.textContent || '[]'); } catch (_) { return () => {}; }
    if (!Array.isArray(source)) return () => {};
    source = source.filter(validReview);
    // Page 1 = the featured block reviews (matched by author + body), then everything else in data order.
    const initialCards = Array.from(grid.childNodes, (child) => child.cloneNode(true));
    const featuredKeys = Array.from(grid.querySelectorAll('.tlo-review-card'), (card) =>
      (card.querySelector('.tlo-review-top strong')?.textContent || '') + '|' + (card.querySelector('.tlo-review-body')?.textContent || ''));
    const keyOf = (review) => review.author + '|' + review.body;
    const featured = featuredKeys.map((key) => source.find((review) => keyOf(review) === key)).filter(Boolean);
    const reviews = [...featured, ...source.filter((review) => !featured.includes(review))];
    const total = reviews.length;
    if (total <= 6) return () => {};
    const text = (key, fallback) => browser.dataset[key] || fallback;
    const firstNextLabel = next.textContent;
    const initialRange = range.textContent;
    let page = 0;
    const pageCount = 1 + Math.ceil((total - 6) / 12);
    const node = (tag, className, value) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (value !== undefined) element.textContent = value;
      return element;
    };
    const card = (review) => {
      const article = node('article', 'tlo-review-card');
      const top = node('div', 'tlo-review-top');
      const date = node('time', '', review.date);
      date.dateTime = review.date;
      top.append(node('strong', '', review.author), date);
      const rating = node('div', 'tlo-review-rating');
      const stars = node('span', 'tlo-review-stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
      stars.setAttribute('aria-hidden', 'true');
      rating.append(stars, node('span', '', `${review.rating} / 5`));
      const body = review.body.trim() ? node('p', 'tlo-review-body', review.body) : node('p', 'tlo-review-empty', text('reviewRatingOnly', 'Rating only'));
      const meta = node('div', 'tlo-review-meta');
      if (review.verified) meta.append(node('span', 'tlo-review-verified', text('reviewVerified', 'Verified purchase on TikTok Shop')));
      article.append(top, rating, body);
      if (review.variant) article.append(node('p', 'tlo-review-variant', review.variant));
      article.append(meta, node('span', 'tlo-review-source', 'TikTok Shop'));
      return article;
    };
    const updateControls = () => {
      previous.disabled = page === 0;
      next.disabled = page >= pageCount - 1;
      next.textContent = page === 0 ? firstNextLabel : text('reviewNext', 'Next reviews');
    };
    const renderPage = (targetPage) => {
      if (isDisposed() || targetPage < 0 || targetPage >= pageCount) return;
      const start = targetPage === 0 ? 0 : 6 + (targetPage - 1) * 12;
      const end = Math.min(total, start + (targetPage === 0 ? 6 : 12));
      const fragment = document.createDocumentFragment();
      reviews.slice(start, end).forEach((review) => fragment.append(card(review)));
      grid.replaceChildren(fragment);
      page = targetPage;
      range.textContent = `${text('reviewShowing', 'Showing')} ${start + 1}–${end} ${text('reviewOf', 'of')} ${total}`;
      status.textContent = range.textContent;
      updateControls();
      grid.focus({preventScroll: true});
      grid.scrollIntoView?.({block: 'start', behavior: 'auto'});
    };
    listen(previous, 'click', () => renderPage(page - 1));
    listen(next, 'click', () => renderPage(page + 1));
    controls.hidden = false;
    updateControls();
    return () => {
      grid.replaceChildren(...initialCards);
      range.textContent = initialRange;
      status.textContent = '';
      controls.hidden = true;
    };
  };
  const initialize = (root) => {
    if (mounted.has(root)) return;

    const controller = new AbortController();
    const listen = (node, type, handler, options = {}) => node?.addEventListener(type, handler, {...options, signal: controller.signal});
    const all = (query) => Array.from(root.querySelectorAll(query));
    const variantInput = root.querySelector('[data-jj-variant-select]');
    const quantityInput = root.querySelector('.jj-product-form [name="quantity"]');
    const packButtons = all('button[data-tp-option-index="1"][data-tp-option-value]');
    const stickyBars = all('[data-tlo-sticky]');
    const purchase = root.querySelector('[data-jj-add]');
    const form = root.querySelector('.jj-product-form');
    const checkoutButton = form?.querySelector('[data-tlo-checkout]');
    const formMessage = form?.querySelector('[data-jj-form-message]');
    const cartLink = form?.querySelector('[data-jj-cart-link]');
    let data = {};
    try { data = JSON.parse(root.querySelector('[data-jj-product-data]')?.textContent || '{}'); } catch (_) {}
    const variants = Array.isArray(data?.variants) ? data.variants.filter((variant) => variant && variant.id != null) : [];
    const selected = (id = variantInput?.value) => variants.find((variant) => String(variant.id) === String(id));
    let disposed = false;
    let observer = null;
    let purchaseObserver = null;
    let checkoutInFlight = false;
    let checkoutCommitted = false;
    let checkoutUncertain = false;
    const checkoutLabel = checkoutButton?.textContent || 'BUY IT NOW';
    const sameSitePath = (value, suffix) => {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || url.username || url.password || url.search || url.hash || !url.pathname.endsWith(suffix)) return '';
        return url.pathname;
      } catch (_) { return ''; }
    };
    const addUrl = sameSitePath(root.dataset.cartAddUrl, '/cart/add.js');
    const checkoutUrl = sameSitePath(root.dataset.tloCheckoutUrl, '/checkout');
    const cartUrl = sameSitePath(root.dataset.cartUrl, '/cart');
    const checkoutReady = Boolean(form && purchase && checkoutButton && addUrl && checkoutUrl && cartUrl && typeof window.fetch === 'function');
    const checkoutLocked = () => checkoutInFlight || checkoutCommitted || checkoutUncertain;
    const showPurchaseMessage = (message, error = false, showBag = false) => {
      if (formMessage) {
        formMessage.textContent = message;
        formMessage.hidden = !message;
        formMessage.classList.toggle('is-error', error);
      }
      if (cartLink) {
        if (cartUrl) cartLink.setAttribute('href', cartUrl);
        cartLink.hidden = !showBag;
      }
    };
    const updateCheckoutState = () => {
      if (!checkoutButton) return;
      checkoutButton.hidden = !checkoutReady;
      checkoutButton.disabled = !checkoutReady || checkoutLocked() || !selected()?.available || purchase?.getAttribute('aria-busy') === 'true';
      if (checkoutLocked() && purchase && !purchase.disabled) purchase.disabled = true;
    };

    const writeText = (node, value) => {
      if (!node) return;
      const text = typeof value === 'string' || typeof value === 'number' ? String(value).trim() : '';
      node.textContent = text;
      node.hidden = !text;
    };
    const setText = (query, value) => all(query).forEach((node) => writeText(node, value));

    const updatePackPrices = (current) => {
      const color = current?.options?.[0];
      packButtons.forEach((button) => {
        const candidate = color == null ? null : variants.find((variant) =>
          Array.isArray(variant.options) && String(variant.options[0]) === String(color) &&
          String(variant.options[1]) === button.dataset.tpOptionValue);
        writeText(button.querySelector('[data-tlo-pack-price]'), candidate?.price || root.dataset.tloUnavailable || 'Not available in this color');
      });
    };

    const positiveInteger = (value, fallback) => {
      const parsed = Number(value);
      return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : fallback;
    };
    const legalQuantity = (value, variant) => {
      if (!variant || !quantityInput) return null;
      const min = positiveInteger(variant.quantityMin, 1);
      const step = positiveInteger(variant.quantityIncrement, 1);
      const rawMax = positiveInteger(variant.quantityMax, Infinity);
      const max = Number.isFinite(rawMax) ? min + Math.floor((rawMax - min) / step) * step : Infinity;
      if (max < min) return null;
      const quantity = Math.max(min, Math.min(max, positiveInteger(value, min)));
      return min + Math.floor((quantity - min) / step) * step;
    };
    const updateDisplayPrice = (variant = selected()) => {
      if (!variant) return;
      const quantity = legalQuantity(quantityInput?.value, variant) || 1;
      const total = Number(variant.priceCents) * quantity;
      const compareTotal = Number(variant.compareCents) * quantity;
      const formatTotal = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.tloCurrency || 'USD'}).format(cents / 100);
      setText('[data-jj-price]', formatTotal(total));
      setText('[data-jj-compare]', variant.onSale ? formatTotal(compareTotal) : '');
      setText('[data-tlo-saving-percent]', variant.onSale ? `SAVE ${variant.savingsPercent}%` : '');
      setText('[data-tlo-saving]', variant.onSale ? `${root.dataset.tloSaveLabel} ${formatTotal(compareTotal - total)}` : '');
      setText('[data-tlo-price-caption]', root.dataset.tloPriceLabel);
      setText('[data-tlo-compare]', variant.onSale ? formatTotal(compareTotal) : '');
      setText('[data-tlo-sticky-price]', formatTotal(total));
    };
    const updateQuantityCards = (variant = selected(), normalize = false) => {
      if (normalize) {
        const quantity = legalQuantity(quantityInput?.value, variant);
        if (quantity !== null) quantityInput.value = String(quantity);
      }
      updateDisplayPrice(variant);
    };
    const normalizeOfferQuantity = () => {
      if (quantityInput) quantityInput.value = '1';
      try {
        const current = new URL(window.location.href);
        if (current.searchParams.has('tlo_qty')) {
          current.searchParams.delete('tlo_qty');
          window.history.replaceState(window.history.state, '', current);
        }
      } catch (_) {}
    };

    const synchronize = (event) => {
      if (disposed || (event && event.target !== root)) return;
      const variant = selected(event?.detail?.variant?.id ?? variantInput?.value);
      setText('[data-tlo-current-title]', variant?.supplyLabel);
      setText('[data-tlo-selected-supply]', variant?.supplyLabel);
      setText('[data-tlo-shipping]', variant?.shippingLabel);
      updatePackPrices(variant);
      updateQuantityCards(variant, true);
      updateCheckoutState();
    };

    listen(form, 'submit', async (event) => {
      const isCheckout = event.submitter === checkoutButton && checkoutButton != null;
      if (!isCheckout && !checkoutLocked()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (disposed || checkoutLocked()) return;
      if (!checkoutReady) return;
      if (purchase.getAttribute('aria-busy') === 'true') {
        showPurchaseMessage('Please wait for your current add-to-bag request to finish.');
        return;
      }
      const variant = selected();
      if (!variant?.available) {
        showPurchaseMessage('This option is sold out. Please choose another option.', true);
        return;
      }
      if (!form.reportValidity()) return;
      const quantity = legalQuantity(quantityInput?.value, variant);
      if (quantity === null || quantity !== Number(quantityInput?.value)) {
        showPurchaseMessage('Please choose a valid quantity for this option.', true);
        return;
      }
      checkoutInFlight = true;
      checkoutButton.setAttribute('aria-busy', 'true');
      checkoutButton.textContent = 'OPENING CHECKOUT…';
      showPurchaseMessage('');
      updateCheckoutState();
      let confirmedFailure = false;
      try {
        const payload = new FormData(form);
        payload.set('quantity', '1');
        const response = await window.fetch(addUrl, {method: 'POST', body: payload, credentials: 'same-origin', headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}});
        const result = await response.json();
        if (!response.ok || Number(result?.status) >= 400) {
          confirmedFailure = true;
          throw new Error(result?.description || result?.message || 'The item could not be added. Please check your selection and try again.');
        }
        const added = Array.isArray(result?.items) ? result.items : [result];
        const confirmed = added.some(item => String(item?.variant_id ?? item?.id) === String(variant.id) || String(item?.parent_relationship?.parent_id) === String(variant.id));
        if (!confirmed && !(variant.requiresComponents && added.length > 0 && added.every(item => item?.key && item?.parent_relationship))) throw new Error('Unconfirmed add response');
        checkoutCommitted = true;
        if (disposed) return;
        showPurchaseMessage('Added to your bag. Opening checkout…', false, true);
        window.location.assign(checkoutUrl);
      } catch (error) {
        if (!confirmedFailure && !checkoutCommitted) checkoutUncertain = true;
        if (disposed) return;
        if (checkoutCommitted) showPurchaseMessage('Your item was added. Open your bag to continue to checkout.', false, true);
        else if (confirmedFailure) showPurchaseMessage(error.message, true);
        else showPurchaseMessage('We could not confirm the result. Please check your bag before trying again.', true, true);
      } finally {
        checkoutInFlight = false;
        if (!disposed) {
          checkoutButton.removeAttribute('aria-busy');
          if (!checkoutCommitted) checkoutButton.textContent = checkoutLabel;
          if (!checkoutLocked()) purchase.disabled = !selected()?.available || purchase.getAttribute('aria-busy') === 'true';
          updateCheckoutState();
        }
      }
    }, {capture: true});
    listen(root, 'sopami:variantchange', synchronize);
    listen(quantityInput, 'input', () => { updateQuantityCards(); });
    listen(quantityInput, 'change', () => { updateQuantityCards(selected(), true); });

    if (checkoutReady && typeof MutationObserver === 'function') {
      purchaseObserver = new MutationObserver(() => { if (!disposed) updateCheckoutState(); });
      purchaseObserver.observe(purchase, {attributes: true, attributeFilter: ['disabled', 'aria-busy']});
    }
    stickyBars.forEach((bar) => { bar.hidden = true; });
    if (stickyBars.length) {
      // Show the sticky bar once the add-to-bag button has scrolled above the viewport. The button is looked up on
      // every check because the product form can be re-rendered after load, which left an observer on a stale node.
      let stickyTicking = false;
      const updateSticky = () => {
        stickyTicking = false;
        if (disposed) return;
        const target = root.querySelector('[data-jj-add]');
        if (!target) return;
        const hide = target.getBoundingClientRect().bottom > 0;
        stickyBars.forEach((bar) => { if (bar.hidden !== hide) bar.hidden = hide; });
      };
      const requestSticky = () => { if (!stickyTicking) { stickyTicking = true; window.requestAnimationFrame(updateSticky); } };
      listen(window, 'scroll', requestSticky, {passive: true});
      listen(window, 'resize', requestSticky);
      updateSticky();
    }

    const cleanupSpotlight = initializeSpotlight(root);
    const cleanupReviews = initializeReviewBrowser(root, listen, () => disposed);
    mounted.set(root, () => {
      disposed = true;
      cleanupReviews();
      cleanupSpotlight();
      observer?.disconnect();
      purchaseObserver?.disconnect();
      controller.abort();
      stickyBars.forEach((bar) => { bar.hidden = true; });
      mounted.delete(root);
    });

    root.classList.add('tlo-enhanced');
    all('[data-tlo-variant-id]').forEach(button => listen(button, 'click', () => {
      if (button.disabled || !variantInput) return;
      quantityInput.value = '1';
      variantInput.value = button.dataset.tloVariantId;
      variantInput.dispatchEvent(new Event('change', {bubbles:true}));

    }));
    const syncPills = () => { all('[data-tlo-variant-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tloVariantId === variantInput.value))); const current = selected(); if (current) setText('[data-tlo-current-title]', current.supplyLabel); };
    listen(root, 'sopami:variantchange', syncPills);
    syncPills();
    all('video').forEach(video => listen(video, 'play', () => all('video').forEach(other => { if (other !== video) other.pause(); })));

    normalizeOfferQuantity();
    synchronize();
  };

  const scan = (scope = document) => {
    if (scope.matches?.(selector)) initialize(scope);
    scope.querySelectorAll?.(selector).forEach(initialize);
  };
  const unload = (scope) => {
    if (scope.matches?.(selector)) mounted.get(scope)?.();
    scope.querySelectorAll?.(selector).forEach((root) => mounted.get(root)?.());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once: true});
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sopami-cart-reward"]) return;
  try {
    
  (() => {
    const controllerSelector = '[data-sopami-cart-reward-controller]';
    const slotSelector = '[data-sopami-cart-reward-slot]';
    const promptKey = 'sopami:cart-reward:save10:prompted:v1';
    const initialize = (root) => {
      if (root.dataset.rewardInitialized === 'true') return;
      const template = root.querySelector('[data-sopami-cart-reward-template]');
      if (!template?.content.firstElementChild) return;
      root.dataset.rewardInitialized = 'true';
      const discountTitle = root.dataset.discountTitle.trim().toLowerCase();
      let lastCart = null;
      let lastState = null;
      let pendingRead = false;
      let readRevision = 0;
      let promptTimer = 0;
      let promptAttempts = 0;
      let promptedHere = false;
      let disposed = false;
      const validCart = (cart) => Boolean(cart && typeof cart.currency === 'string' && Number.isSafeInteger(cart.items_subtotal_price) && cart.items_subtotal_price >= 0 && Number.isSafeInteger(cart.item_count) && Array.isArray(cart.items));
      const deriveReward = (cart) => {
        if (!validCart(cart) || cart.currency !== 'USD' || cart.item_count === 0 || cart.items_subtotal_price < 5000) return {visible: false};
        const subtotal = cart.items_subtotal_price;
        const applied = Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.some((discount) => String(discount.title || '').trim().toLowerCase() === discountTitle && discount.value_type === 'fixed_amount' && Number(discount.total_allocated_amount) === 1000);
        return {visible: true, remaining: Math.max(0, 7900 - subtotal), progress: Math.min(100, subtotal / 7900 * 100), state: applied ? 'applied' : subtotal >= 7900 ? 'ready' : 'progress'};
      };
      const formatUsd = (cents) => {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol'}).format(cents / 100); }
        catch { return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(cents / 100); }
      };
      const prompted = () => {
        if (promptedHere) return true;
        try { return sessionStorage.getItem(promptKey) === '1'; } catch { return false; }
      };
      const markPrompted = () => {
        promptedHere = true;
        clearTimeout(promptTimer);
        try { sessionStorage.setItem(promptKey, '1'); } catch {}
      };
      const visible = (element) => {
        if (!element?.isConnected || !element.getClientRects().length) return false;
        const style = getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      };
      const bagShowsReward = () => {
        const bag = document.querySelector('#jj-bag');
        const card = bag?.querySelector('[data-sopami-cart-reward-card]');
        return Boolean(bag?.open && visible(bag) && card && visible(card));
      };
      const blockingOverlay = () => {
        const roots = [document];
        for (let i = 0; i < roots.length && i < 24; i += 1) {
          const scope = roots[i];
          if (Array.from(scope.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"]')).some(visible)) return true;
          for (const element of scope.querySelectorAll('*')) if (element.shadowRoot) roots.push(element.shadowRoot);
        }
        return ['hidden', 'clip'].includes(getComputedStyle(document.body).overflowY) || ['hidden', 'clip'].includes(getComputedStyle(document.documentElement).overflowY);
      };
      const editing = () => {
        let active = document.activeElement;
        for (let depth = 0; depth < 8 && active?.shadowRoot?.activeElement; depth += 1) active = active.shadowRoot.activeElement;
        return Boolean(active && (active.matches('input, textarea, select') || active.isContentEditable));
      };
      const render = (state) => {
        document.querySelectorAll(slotSelector).forEach((slot) => {
          slot.hidden = !state.visible;
          if (!state.visible) return;
          let card = slot.querySelector('[data-sopami-cart-reward-card]');
          if (!card) { card = template.content.firstElementChild.cloneNode(true); card.dataset.rewardOwner = root.dataset.sectionId; slot.append(card); }
          card.dataset.rewardState = state.state;
          const status = card.querySelector('[data-cart-reward-status]');
          const text = state.state === 'applied' ? root.dataset.appliedCopy : state.state === 'ready' ? root.dataset.readyCopy : root.dataset.progressCopy.replace('__AMOUNT__', formatUsd(state.remaining));
          if (status.textContent !== text) status.textContent = text;
          card.querySelector('[data-cart-reward-progress]').style.width = `${state.progress}%`;
          card.querySelector('[data-cart-reward-bag-link]').hidden = root.dataset.pageType === 'cart';
        });
      };
      const tryPrompt = () => {
        promptTimer = 0;
        if (disposed || !lastState?.visible || prompted()) return;
        if (bagShowsReward()) { markPrompted(); return; }
        if (root.dataset.pageType !== 'cart' || root.dataset.designMode === 'true') return;
        if (document.visibilityState !== 'visible' || blockingOverlay() || editing()) {
          promptAttempts += 1;
          if (promptAttempts < 12) promptTimer = setTimeout(tryPrompt, 2500);
          return;
        }
        const opener = document.querySelector('[data-jj-open="bag"]');
        if (!opener || !document.querySelector('#jj-bag')) return;
        opener.click();
        if (bagShowsReward()) markPrompted();
      };
      const receive = (cart) => {
        if (!validCart(cart) || disposed) return;
        lastCart = cart;
        lastState = deriveReward(cart);
        render(lastState);
        if (lastState.visible && bagShowsReward()) markPrompted();
        clearTimeout(promptTimer);
        if (lastState.visible && !prompted() && root.dataset.pageType === 'cart' && root.dataset.designMode !== 'true') promptTimer = setTimeout(tryPrompt, 450);
      };
      const readCart = async () => {
        if (pendingRead || disposed) return;
        pendingRead = true;
        const revision = readRevision;
        try {
          const response = await fetch(root.dataset.cartUrl, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
          if (!response.ok) return;
          const cart = await response.json();
          if (readRevision === revision) receive(cart);
        } catch {} finally { pendingRead = false; }
      };
      const onCartRead = (event) => {
        if (!validCart(event.detail)) { readCart(); return; }
        readRevision += 1;
        receive(event.detail);
      };
      const onPageShow = (event) => { if (event.persisted) readCart(); };
      const onSectionLoad = () => { if (lastCart) receive(lastCart); };
      const onSectionUnload = (event) => {
        if (event.detail?.sectionId !== root.dataset.sectionId) return;
        disposed = true;
        clearTimeout(promptTimer);
        document.removeEventListener('sopami:cartread', onCartRead);
        window.removeEventListener('pageshow', onPageShow);
        document.removeEventListener('shopify:section:load', onSectionLoad);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        document.querySelectorAll('[data-sopami-cart-reward-card]').forEach((card) => { if (card.dataset.rewardOwner === root.dataset.sectionId) { card.closest(slotSelector).hidden = true; card.remove(); } });
      };
      document.addEventListener('sopami:cartread', onCartRead);
      window.addEventListener('pageshow', onPageShow);
      document.addEventListener('shopify:section:load', onSectionLoad);
      document.addEventListener('shopify:section:unload', onSectionUnload);
      readCart();
    };
    const scan = (scope) => {
      if (scope.matches?.(controllerSelector)) initialize(scope);
      scope.querySelectorAll(controllerSelector).forEach(initialize);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once: true});
    else scan(document);
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sopami-product-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const variants = JSON.parse(root.querySelector('[data-slo-variants]').textContent);
    const labels = JSON.parse(root.querySelector('[data-slo-labels]').textContent);
    const form = root.querySelector('.slo-form');
    const qty = form.elements.quantity;
    const message = root.querySelector('[data-slo-message]');
    const buttons = [...form.querySelectorAll('[type=submit]')];
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency});
    const money = cents => formatter.format(cents / 100);
    const chosen = () => variants.find(v => String(v.id) === form.elements.id.value) || variants[0];
    let busy = false;
    const countdown = root.querySelector('[data-shark-countdown]');
    if (countdown) {
      const storageKey = 'sopami-shark-spotlight-end-v1';
      const cycleMs = 60 * 60 * 1000;
      let endAt;
      try { endAt = Number(localStorage.getItem(storageKey)); } catch { endAt = 0; }
      if (!Number.isFinite(endAt) || endAt <= 0 || endAt > Date.now() + cycleMs) {
        endAt = Date.now() + cycleMs;
        try { localStorage.setItem(storageKey, String(endAt)); } catch {}
      }
      const tick = () => {
        const now = Date.now();
        if (now >= endAt) {
          endAt += (Math.floor((now - endAt) / cycleMs) + 1) * cycleMs;
          try { localStorage.setItem(storageKey, String(endAt)); } catch {}
        }
        const remaining = Math.max(1, Math.ceil((endAt - now) / 1000));
        const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        countdown.textContent = `${hours}:${minutes}:${seconds}`;
      };
      tick();
      setInterval(tick, 1000);
    }
    const showImage = (url, alt) => {
      if (!url) return;
      const img = root.querySelector('.slo-main-image');
      img.src = url; img.removeAttribute('srcset'); img.alt = alt || labels.shortTitle;
      root.querySelector('[data-slo-zoom]').href = url;
      root.querySelectorAll('[data-slo-image]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.sloImage === url)));
    };
    root.querySelectorAll('[data-slo-image]').forEach(b => b.addEventListener('click',() => showImage(b.dataset.sloImage,b.dataset.sloImageAlt)));
    const update = (variantChanged=false) => {
      const v = chosen();
      root.querySelector('[data-slo-price]').textContent = money(v.price);
      root.querySelector('[data-slo-sticky-price]').textContent = money(v.price);
      root.querySelector('[data-slo-sticky-label]').textContent = v.title === 'Default Title' ? labels.shortTitle : v.title;
      const compare = root.querySelector('[data-slo-compare]');
      const referencePrice = root.classList.contains('shark-offer') ? 9900 : v.compare;
      compare.hidden = !(referencePrice > v.price); compare.textContent = money(referencePrice);
      const discounted = root.querySelector('[data-slo-discounted]');
      if(discounted) discounted.textContent = money(Math.round(v.price * .9));
      const savings=root.querySelector('[data-shark-saving]');
      if(savings) savings.textContent=money(Math.max(0, referencePrice-v.price));
      root.querySelector('[data-slo-stock]').textContent = v.available ? labels.inStock : labels.soldOut;
      buttons.forEach(b => b.disabled = busy || !v.available);
      qty.min = v.min; qty.step = v.step; v.max ? qty.max = v.max : qty.removeAttribute('max');
      root.querySelectorAll('[data-slo-total]').forEach(n => {
        const count = Number(n.dataset.sloTotal);
        const factor = root.classList.contains('shark-offer') && count === 2 ? .95 : root.classList.contains('shark-offer') && count === 3 ? .9 : 1;
        n.textContent = money((v.price - Math.floor(v.price * (1 - factor))) * count);
      });
      root.querySelectorAll('[data-slo-regular]').forEach(n => n.textContent = money(v.price * Number(n.dataset.sloRegular)));
      root.querySelectorAll('[data-slo-quantity]').forEach(b => {
        const n=Number(b.dataset.sloQuantity);
        b.disabled = n<v.min || (n-v.min)%v.step!==0 || (v.max && n>v.max);
        b.setAttribute('aria-pressed',String(Number(qty.value) === n));
      });
      if(variantChanged){
        showImage(v.image);
        const url = new URL(location.href); url.searchParams.set('variant',v.id); history.replaceState(null,'',url);
      }
    };
    form.querySelectorAll('[name=id]').forEach(i => i.addEventListener('change',() => {
      const v=chosen();qty.value = v.min;update(true);
    }));
    qty.addEventListener('input',() => update());
    root.querySelectorAll('[data-slo-quantity]').forEach(b => b.addEventListener('click',() => {qty.value=b.dataset.sloQuantity;update();}));
    form.addEventListener('submit',async event => {
      event.preventDefault();
      if(busy || !form.reportValidity()) return;
      const v=chosen(),quantity=Number(qty.value),checkout=event.submitter?.hasAttribute('data-slo-checkout');
      if(!v.available || !Number.isInteger(quantity) || quantity < v.min || (quantity-v.min)%v.step!==0 || (v.max && quantity>v.max)) return;
      busy=true;update();message.textContent=root.dataset.adding;
      try{
        const response=await fetch(root.dataset.add,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity}]})});
        const result=await response.json();
        if(!response.ok) throw new Error(typeof result.description==='string'?result.description:root.dataset.error);
        if(checkout){location.assign(root.dataset.root+'checkout');return;}
        message.textContent=root.dataset.added;
        root.querySelector('[data-slo-cart-link]').hidden=false;
        try{const cart=await fetch(root.dataset.cart+'.js',{credentials:'same-origin'}).then(r=>r.json());root.querySelector('[data-slo-bag-count]').textContent=cart.item_count;}catch{}
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }catch(error){message.textContent=error.message || root.dataset.error;}
      finally{busy=false;update();}
    });
    const reviewData=root.querySelector('[data-slo-review-data]'),pager=root.querySelector('[data-slo-pagination]');
    if(reviewData && pager){
      const reviews=JSON.parse(reviewData.textContent),reviewLabels=JSON.parse(root.querySelector('[data-slo-review-labels]').textContent),grid=root.querySelector('[data-slo-reviews]');
      let page=0;const last=Math.ceil(reviews.length/6)-1;
      const el=(tag,text,className)=>{const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(className)n.className=className;return n;};
      const render=()=>{
        const cards=reviews.slice(page*6,page*6+6).map(r=>{
          const card=el('article',undefined,'slo-review');card.dataset.reviewId=r.id;
          const heading=el('div'),date=el('time',r.date);date.dateTime=r.date;heading.append(el('strong',r.author),date);
          const stars=el('p','★'.repeat(r.rating)+'☆'.repeat(5-r.rating),'slo-stars');stars.setAttribute('aria-label',reviewLabels.rating.replace('[rating]',r.rating));
          const body=el('p',r.body||reviewLabels.ratingOnly,'slo-review-body');
          card.append(heading,stars,body,el('small',r.variant));
          if(r.verified)card.append(el('small',reviewLabels.verified));
          if(r.incentivized)card.append(el('small',reviewLabels.incentivized));
          card.append(el('small',reviewLabels.source));return card;
        });
        grid.replaceChildren(...cards);
        pager.querySelector('[data-slo-range]').textContent=(page*6+1)+'–'+Math.min((page+1)*6,reviews.length)+' / '+reviews.length;
        pager.querySelector('[data-slo-prev]').disabled=page===0;pager.querySelector('[data-slo-next]').disabled=page===last;
      };
      pager.hidden=reviews.length<=6;
      for(const direction of ['prev','next'])pager.querySelector('[data-slo-'+direction+']').addEventListener('click',()=>{page=Math.max(0,Math.min(last,page+(direction==='next'?1:-1)));render();grid.focus({preventScroll:true});grid.scrollIntoView({block:'start',behavior:'auto'});});
      render();
    }
    update();
  };
  document.querySelectorAll('[data-slo]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-slo]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sopami-washer-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  const selector = '.tlo[data-washer-direct]';
  const mounted = new WeakMap();
const initializeSpotlight = (root) => {
  const panel = root.querySelector('[data-tlo-spotlight]');
  const timers = root.querySelectorAll('[data-tlo-spotlight-timer]');
  const copy = panel?.querySelector('[data-tlo-spotlight-copy]');
  if (!panel || !timers.length || !copy) return () => {};
  const duration = 60 * 60 * 1000;
  const key = 'sopami:offer-spotlight:v2:' + root.dataset.productHandle;
  const messages = [panel.dataset.spotlightFirst, panel.dataset.spotlightSecond];
  let state;
  try { state = JSON.parse(localStorage.getItem(key)); } catch (_) {}
  const now = Date.now();
  if (!state || !Number.isFinite(state.endsAt) || state.endsAt > now + duration || !Number.isInteger(state.index) || state.index < 0 || state.index >= messages.length) {
    state = {endsAt: now + duration, index: 0};
  }
  const persist = () => { try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {} };
  const tick = () => {
    const current = Date.now();
    if (current >= state.endsAt) {
      const elapsed = Math.floor((current - state.endsAt) / duration) + 1;
      state.index = (state.index + elapsed) % messages.length;
      state.endsAt += elapsed * duration;
      persist();
    }
    const remaining = Math.max(0, Math.ceil((state.endsAt - current) / 1000));
    const digits = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60].map(value => String(value).padStart(2, '0')).join(':');
    timers.forEach(timer => { if (timer.textContent !== digits) timer.textContent = digits; });
    if (copy.textContent !== messages[state.index]) copy.textContent = messages[state.index];
  };
  persist();
  tick();
  panel.hidden = false;
  const interval = setInterval(tick, 1000);
  return () => clearInterval(interval);
};

  const initializeReviewBrowser = (root, listen, isDisposed) => {
    const browser = root.querySelector('[data-tlo-review-browser]');
    const grid = browser?.querySelector('[data-tlo-review-grid]');
    const controls = browser?.querySelector('[data-tlo-review-controls]');
    const previous = browser?.querySelector('[data-tlo-review-previous]');
    const next = browser?.querySelector('[data-tlo-review-next]');
    const status = browser?.querySelector('[data-tlo-review-status]');
    const range = browser?.querySelector('[data-tlo-review-range]');
    const total = Number(browser?.dataset.reviewCount);
    if (!grid || !controls || !previous || !next || !status || !range || !Number.isSafeInteger(total) || total <= 6 || total > 10000 || typeof window.fetch !== 'function') return () => {};
    let assetUrl;
    let sourceUrl;
    try {
      assetUrl = new URL(browser.dataset.reviewUrl, window.location.href);
      sourceUrl = new URL(browser.dataset.reviewSource);
      if (assetUrl.protocol !== 'https:' || assetUrl.username || assetUrl.password || assetUrl.port || assetUrl.hash || !assetUrl.pathname.endsWith('/assets/washer-offer-reviews.json') || (assetUrl.origin !== window.location.origin && assetUrl.hostname !== 'cdn.shopify.com')) return () => {};
      if (sourceUrl.href !== 'https://shop.tiktok.com/us/pdp/1732062795748381230') return () => {};
    } catch (_) { return () => {}; }
    const text = (key, fallback) => browser.dataset[key] || fallback;
    const firstNextLabel = next.textContent;
    const initialCards = Array.from(grid.childNodes, (child) => child.cloneNode(true));
    const initialRange = range.textContent;
    let reviews = null;
    let page = 0;
    let pending = false;
    let request = null;
    let timeout = null;
    const pageCount = 1 + Math.ceil((total - 6) / 12);
    const node = (tag, className, value) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (value !== undefined) element.textContent = value;
      return element;
    };
    const validReview = (review) => {
      if (!review || !Number.isInteger(review.rating) || review.rating < 4 || review.rating > 5 || typeof review.verifiedPurchase !== 'boolean') return false;
      for (const [field, max] of [['author', 100], ['body', 5000], ['variant', 500], ['country', 100]]) {
        if (typeof review[field] !== 'string' || review[field].length > max) return false;
      }
      if (!review.author.trim() || !review.author.includes('*') || !review.variant.trim()) return false;
      return typeof review.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(review.date) && Number.isFinite(Date.parse(review.date)) && new Date(review.date).toISOString().slice(0, 10) === review.date;
    };
    const card = (review) => {
      const article = node('article', 'tlo-review-card');
      const top = node('div', 'tlo-review-top');
      const date = node('time', '', review.date);
      date.dateTime = review.date;
      top.append(node('strong', '', review.author), date);
      const rating = node('div', 'tlo-review-rating');
      const stars = node('span', 'tlo-review-stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
      stars.setAttribute('aria-hidden', 'true');
      rating.append(stars, node('span', '', `${review.rating} / 5`));
      const body = review.body.trim() ? node('p', 'tlo-review-body', review.body) : node('p', 'tlo-review-empty', text('reviewRatingOnly', 'Rating only'));
      const meta = node('div', 'tlo-review-meta');
      if (review.verifiedPurchase) meta.append(node('span', 'tlo-review-verified', text('reviewVerified', 'Verified purchase on TikTok Shop')));
      if (review.country) meta.append(node('span', '', review.country));
      const source = node('span', 'tlo-review-source', 'TikTok Shop');
      article.append(top, rating, body, node('p', 'tlo-review-variant', review.variant), meta, source);
      return article;
    };
    const updateControls = () => {
      previous.disabled = pending || page === 0;
      next.disabled = pending || page >= pageCount - 1;
      if (!pending) next.textContent = page === 0 ? firstNextLabel : text('reviewNext', 'Next reviews');
      grid.setAttribute('aria-busy', String(pending));
    };
    const renderPage = (targetPage) => {
      const start = targetPage === 0 ? 0 : 6 + (targetPage - 1) * 12;
      const end = Math.min(total, start + (targetPage === 0 ? 6 : 12));
      const fragment = document.createDocumentFragment();
      reviews.slice(start, end).forEach((review) => fragment.append(card(review)));
      grid.replaceChildren(fragment);
      page = targetPage;
      range.textContent = `${text('reviewShowing', 'Showing')} ${start + 1}–${end} ${text('reviewOf', 'of')} ${total}`;
      status.textContent = range.textContent;
      grid.focus({preventScroll: true});
      grid.scrollIntoView?.({block: 'start', behavior: 'auto'});
    };
    const changePage = async (targetPage) => {
      if (isDisposed() || pending || targetPage < 0 || targetPage >= pageCount) return;
      pending = true;
      updateControls();
      next.textContent = text('reviewLoading', 'Loading reviews…');
      status.textContent = text('reviewLoading', 'Loading reviews…');
      let failed = false;
      try {
        if (!reviews) {
          request = new AbortController();
          timeout = window.setTimeout(() => request?.abort(), 15000);
          const response = await window.fetch(assetUrl.href, {credentials: 'omit', headers: {Accept: 'application/json'}, signal: request.signal});
          if (!response.ok) throw new Error('Review request failed');
          const result = await response.json();
          if (isDisposed()) return;
          if (result?.version !== 1 || result.mode !== 'curated-positive' || result.sourceUrl !== sourceUrl.href || result.importedCount !== total || !Array.isArray(result.reviews) || result.reviews.length !== total || !result.reviews.every(validReview)) throw new Error('Invalid review collection');
          reviews = result.reviews;
        }
        if (!isDisposed()) renderPage(targetPage);
      } catch (_) {
        failed = true;
        if (!isDisposed()) status.textContent = text('reviewError', 'Reviews could not load. Please try again.');
      } finally {
        if (timeout !== null) window.clearTimeout(timeout);
        timeout = null;
        request = null;
        pending = false;
        if (!isDisposed()) {
          updateControls();
          if (failed) next.textContent = text('reviewRetry', 'Try again');
        }
      }
    };
    listen(previous, 'click', () => changePage(page - 1));
    listen(next, 'click', () => changePage(page + 1));
    controls.hidden = false;
    updateControls();
    return () => {
      request?.abort();
      if (timeout !== null) window.clearTimeout(timeout);
      grid.replaceChildren(...initialCards);
      grid.removeAttribute('aria-busy');
      range.textContent = initialRange;
      status.textContent = '';
      controls.hidden = true;
    };
  };
  const initialize = (root) => {
    if (mounted.has(root)) return;

    const controller = new AbortController();
    const listen = (node, type, handler, options = {}) => node?.addEventListener(type, handler, {...options, signal: controller.signal});
    const all = (query) => Array.from(root.querySelectorAll(query));
    const variantInput = root.querySelector('[data-jj-variant-select]');
    const quantityInput = root.querySelector('.jj-product-form [name="quantity"]');
    const packButtons = all('button[data-tp-option-index="1"][data-tp-option-value]');
    const stickyBars = all('[data-tlo-sticky]');
    const purchase = root.querySelector('[data-jj-add]');
    const form = root.querySelector('.jj-product-form');
    const checkoutButton = form?.querySelector('[data-tlo-checkout]');
    const formMessage = form?.querySelector('[data-jj-form-message]');
    const cartLink = form?.querySelector('[data-jj-cart-link]');
    let data = {};
    try { data = JSON.parse(root.querySelector('[data-jj-product-data]')?.textContent || '{}'); } catch (_) {}
    const variants = Array.isArray(data?.variants) ? data.variants.filter((variant) => variant && variant.id != null) : [];
    const selected = (id = variantInput?.value) => variants.find((variant) => String(variant.id) === String(id));
    let disposed = false;
    let observer = null;
    let purchaseObserver = null;
    let checkoutInFlight = false;
    let checkoutCommitted = false;
    let checkoutUncertain = false;
    const checkoutLabel = checkoutButton?.textContent || 'BUY IT NOW';
    const sameSitePath = (value, suffix) => {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || url.username || url.password || url.search || url.hash || !url.pathname.endsWith(suffix)) return '';
        return url.pathname;
      } catch (_) { return ''; }
    };
    const addUrl = sameSitePath(root.dataset.cartAddUrl, '/cart/add.js');
    const checkoutUrl = sameSitePath(root.dataset.tloCheckoutUrl, '/checkout');
    const cartUrl = sameSitePath(root.dataset.cartUrl, '/cart');
    const checkoutReady = Boolean(form && purchase && checkoutButton && addUrl && checkoutUrl && cartUrl && typeof window.fetch === 'function');
    const checkoutLocked = () => checkoutInFlight || checkoutCommitted || checkoutUncertain;
    const showPurchaseMessage = (message, error = false, showBag = false) => {
      if (formMessage) {
        formMessage.textContent = message;
        formMessage.hidden = !message;
        formMessage.classList.toggle('is-error', error);
      }
      if (cartLink) {
        if (cartUrl) cartLink.setAttribute('href', cartUrl);
        cartLink.hidden = !showBag;
      }
    };
    const updateCheckoutState = () => {
      if (!checkoutButton) return;
      checkoutButton.hidden = !checkoutReady;
      checkoutButton.disabled = !checkoutReady || checkoutLocked() || !selected()?.available || purchase?.getAttribute('aria-busy') === 'true';
      if (checkoutLocked() && purchase && !purchase.disabled) purchase.disabled = true;
    };

    const writeText = (node, value) => {
      if (!node) return;
      const text = typeof value === 'string' || typeof value === 'number' ? String(value).trim() : '';
      node.textContent = text;
      node.hidden = !text;
    };
    const setText = (query, value) => all(query).forEach((node) => writeText(node, value));

    const updatePackPrices = (current) => {
      const color = current?.options?.[0];
      packButtons.forEach((button) => {
        const candidate = color == null ? null : variants.find((variant) =>
          Array.isArray(variant.options) && String(variant.options[0]) === String(color) &&
          String(variant.options[1]) === button.dataset.tpOptionValue);
        writeText(button.querySelector('[data-tlo-pack-price]'), candidate?.price || root.dataset.tloUnavailable || 'Not available in this color');
      });
    };

    const positiveInteger = (value, fallback) => {
      const parsed = Number(value);
      return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : fallback;
    };
    const legalQuantity = (value, variant) => {
      if (!variant || !quantityInput) return null;
      const min = positiveInteger(variant.quantityMin, 1);
      const step = positiveInteger(variant.quantityIncrement, 1);
      const rawMax = positiveInteger(variant.quantityMax, Infinity);
      const max = Number.isFinite(rawMax) ? min + Math.floor((rawMax - min) / step) * step : Infinity;
      if (max < min) return null;
      const quantity = Math.max(min, Math.min(max, positiveInteger(value, min)));
      return min + Math.floor((quantity - min) / step) * step;
    };
    const updateDisplayPrice = (variant = selected()) => {
      if (!variant) return;
      const quantity = legalQuantity(quantityInput?.value, variant) || 1;
      const total = Number(variant.priceCents) * quantity;
      const compareTotal = Number(variant.compareCents) * quantity;
      const formatTotal = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.tloCurrency || 'USD'}).format(cents / 100);
      setText('[data-jj-price]', formatTotal(total));
      setText('[data-jj-compare]', variant.onSale ? formatTotal(compareTotal) : '');
      const valuePack = variant.sku === 'XYJPTP-4';
      const valueDetail = valuePack ? root.dataset.washerValueDetail.replace('__PRICE__', formatTotal(Math.round(Number(variant.priceCents) / 48))) : '';
      setText('[data-tlo-saving-percent]', variant.onSale ? `SAVE ${variant.savingsPercent}%` : valuePack ? root.dataset.washerValueBadge : '');
      setText('[data-tlo-saving]', variant.onSale ? `${root.dataset.tloSaveLabel} ${formatTotal(compareTotal - total)}` : valueDetail);
      setText('[data-tlo-price-caption]', root.dataset.tloPriceLabel);
      setText('[data-tlo-compare]', variant.onSale ? formatTotal(compareTotal) : '');
      setText('[data-tlo-sticky-price]', formatTotal(total));
    };
    const updateQuantityCards = (variant = selected(), normalize = false) => {
      if (normalize) {
        const quantity = legalQuantity(quantityInput?.value, variant);
        if (quantity !== null) quantityInput.value = String(quantity);
      }
      updateDisplayPrice(variant);
    };
    const normalizeOfferQuantity = () => {
      if (quantityInput) quantityInput.value = '1';
      try {
        const current = new URL(window.location.href);
        if (current.searchParams.has('tlo_qty')) {
          current.searchParams.delete('tlo_qty');
          window.history.replaceState(window.history.state, '', current);
        }
      } catch (_) {}
    };

    const synchronize = (event) => {
      if (disposed || (event && event.target !== root)) return;
      const variant = selected(event?.detail?.variant?.id ?? variantInput?.value);
      setText('[data-tlo-current-title]', variant?.supplyLabel);
      setText('[data-tlo-selected-supply]', variant?.supplyLabel);
      updatePackPrices(variant);
      updateQuantityCards(variant, true);
      updateCheckoutState();
    };

    listen(form, 'submit', async (event) => {
      const isCheckout = event.submitter === checkoutButton && checkoutButton != null;
      if (!isCheckout && !checkoutLocked()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (disposed || checkoutLocked()) return;
      if (!checkoutReady) return;
      if (purchase.getAttribute('aria-busy') === 'true') {
        showPurchaseMessage('Please wait for your current add-to-bag request to finish.');
        return;
      }
      const variant = selected();
      if (!variant?.available) {
        showPurchaseMessage('This option is sold out. Please choose another option.', true);
        return;
      }
      if (!form.reportValidity()) return;
      const quantity = legalQuantity(quantityInput?.value, variant);
      if (quantity === null || quantity !== Number(quantityInput?.value)) {
        showPurchaseMessage('Please choose a valid quantity for this option.', true);
        return;
      }
      checkoutInFlight = true;
      checkoutButton.setAttribute('aria-busy', 'true');
      checkoutButton.textContent = 'OPENING CHECKOUT…';
      showPurchaseMessage('');
      updateCheckoutState();
      let confirmedFailure = false;
      try {
        const payload = new FormData(form);
        payload.set('quantity', '1');
        const response = await window.fetch(addUrl, {method: 'POST', body: payload, credentials: 'same-origin', headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}});
        const result = await response.json();
        if (!response.ok || Number(result?.status) >= 400) {
          confirmedFailure = true;
          throw new Error(result?.description || result?.message || 'The item could not be added. Please check your selection and try again.');
        }
        const added = Array.isArray(result?.items) ? result.items : [result];
        const confirmed = added.some(item => String(item?.variant_id ?? item?.id) === String(variant.id) || String(item?.parent_relationship?.parent_id) === String(variant.id));
        if (!confirmed && !(variant.requiresComponents && added.length > 0 && added.every(item => item?.key && item?.parent_relationship))) throw new Error('Unconfirmed add response');
        checkoutCommitted = true;
        if (disposed) return;
        showPurchaseMessage('Added to your bag. Opening checkout…', false, true);
        window.location.assign(checkoutUrl);
      } catch (error) {
        if (!confirmedFailure && !checkoutCommitted) checkoutUncertain = true;
        if (disposed) return;
        if (checkoutCommitted) showPurchaseMessage('Your item was added. Open your bag to continue to checkout.', false, true);
        else if (confirmedFailure) showPurchaseMessage(error.message, true);
        else showPurchaseMessage('We could not confirm the result. Please check your bag before trying again.', true, true);
      } finally {
        checkoutInFlight = false;
        if (!disposed) {
          checkoutButton.removeAttribute('aria-busy');
          if (!checkoutCommitted) checkoutButton.textContent = checkoutLabel;
          if (!checkoutLocked()) purchase.disabled = !selected()?.available || purchase.getAttribute('aria-busy') === 'true';
          updateCheckoutState();
        }
      }
    }, {capture: true});
    listen(root, 'sopami:variantchange', synchronize);
    listen(quantityInput, 'input', () => { updateQuantityCards(); });
    listen(quantityInput, 'change', () => { updateQuantityCards(selected(), true); });

    if (checkoutReady && typeof MutationObserver === 'function') {
      purchaseObserver = new MutationObserver(() => { if (!disposed) updateCheckoutState(); });
      purchaseObserver.observe(purchase, {attributes: true, attributeFilter: ['disabled', 'aria-busy']});
    }
    stickyBars.forEach((bar) => { bar.hidden = true; });
    if (purchase && stickyBars.length && typeof IntersectionObserver === 'function') {
      observer = new IntersectionObserver((entries) => {
        if (disposed) return;
        const entry = entries.find((item) => item.target === purchase);
        if (entry) stickyBars.forEach((bar) => { bar.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0; });
      }, {threshold: 0});
      observer.observe(purchase);
    }

    const cleanupSpotlight = initializeSpotlight(root);
    const cleanupReviews = initializeReviewBrowser(root, listen, () => disposed);
    mounted.set(root, () => {
      disposed = true;
      cleanupReviews();
      cleanupSpotlight();
      observer?.disconnect();
      purchaseObserver?.disconnect();
      controller.abort();
      stickyBars.forEach((bar) => { bar.hidden = true; });
      mounted.delete(root);
    });

    root.classList.add('tlo-enhanced');
    all('[data-tlo-variant-id]').forEach(button => listen(button, 'click', () => {
      if (button.disabled || !variantInput) return;
      quantityInput.value = '1';
      variantInput.value = button.dataset.tloVariantId;
      variantInput.dispatchEvent(new Event('change', {bubbles:true}));

    }));
    const syncPills = () => { all('[data-tlo-variant-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tloVariantId === variantInput.value))); const current = selected(); if (current) setText('[data-tlo-current-title]', current.supplyLabel); };
    listen(root, 'sopami:variantchange', syncPills);
    syncPills();
    all('video').forEach(video => listen(video, 'play', () => all('video').forEach(other => { if (other !== video) other.pause(); })));

    const updateCouponPrice = () => { const v = selected(); const n = root.querySelector('[data-washer-discounted]'); if (v && n) n.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.tloCurrency || 'USD'}).format((v.priceCents - Math.floor(v.priceCents * 0.1))/100); };
    listen(root, 'sopami:variantchange', updateCouponPrice);
    updateCouponPrice();
    normalizeOfferQuantity();
    synchronize();
  };

  const scan = (scope = document) => {
    if (scope.matches?.(selector)) initialize(scope);
    scope.querySelectorAll?.(selector).forEach(initialize);
  };
  const unload = (scope) => {
    if (scope.matches?.(selector)) mounted.get(scope)?.();
    scope.querySelectorAll?.(selector).forEach((root) => mounted.get(root)?.());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once: true});
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sopami-welcome-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-sopami-offer-root]';
    const dismissKey = 'sopami:welcome-offer:v1:dismissed';
    const claimedKey = 'sopami:welcome-offer:v1:claimed';
    const storageRead = (key) => {
      try { const value = localStorage.getItem(key); if (value !== null) return value; } catch {}
      try { return sessionStorage.getItem(key); } catch { return null; }
    };
    const storageWrite = (key, value) => {
      try { localStorage.setItem(key, value); } catch {}
      try { sessionStorage.setItem(key, value); } catch {}
    };
    const initialize = (root) => {
      if (root.dataset.offerInitialized) return;
      const dialog = root.querySelector('[data-sopami-offer]');
      const launcher = root.querySelector('[data-offer-open]');
      if (!dialog || !launcher || typeof dialog.showModal !== 'function') return;
      root.dataset.offerInitialized = 'true';
      launcher.hidden = false;
      const response = root.querySelector('[data-offer-response]');
      const success = response?.dataset.serverSuccess === 'true';
      const errors = response?.dataset.serverErrors === 'true';
      const form = root.querySelector('form');
      const submit = root.querySelector('[data-offer-submit]');
      const submitLabel = root.querySelector('[data-offer-submit-label]');
      const originalSubmitLabel = submitLabel?.textContent || '';
      const dismissDays = Math.min(30, Math.max(1, Number(root.dataset.dismissDays) || 7));
      const delay = Math.min(60, Math.max(3, Number(root.dataset.delay) || 12)) * 1000;
      let lastFocus = null;
      let previousBodyOverflow = '';
      let previousHtmlOverflow = '';
      let ownsScrollLock = false;
      let timer = 0;
      let attempts = 0;
      let removed = false;
      let dismissedHere = false;
      const anotherDialogOpen = () => Array.from(document.querySelectorAll('dialog[open]')).some((item) => item !== dialog);
      const open = () => {
        if (removed || dialog.open || anotherDialogOpen()) return false;
        lastFocus = document.activeElement;
        try { dialog.showModal(); } catch { return false; }
        previousBodyOverflow = document.body.style.overflow;
        previousHtmlOverflow = document.documentElement.style.overflow;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        ownsScrollLock = true;
        launcher.hidden = true;
        root.querySelector('[data-offer-focus]')?.focus({ preventScroll: true });
        return true;
      };
      const restore = () => {
        if (ownsScrollLock && !anotherDialogOpen()) {
          document.body.style.overflow = previousBodyOverflow;
          document.documentElement.style.overflow = previousHtmlOverflow;
        }
        ownsScrollLock = false;
        launcher.hidden = false;
        if (lastFocus?.isConnected && lastFocus !== document.body) lastFocus.focus({ preventScroll: true });
      };
      const close = () => {
        clearTimeout(timer);
        dismissedHere = true;
        if (!success) storageWrite(dismissKey, String(Date.now()));
        if (dialog.open) dialog.close();
      };
      const eligible = () => {
        if (dismissedHere || root.dataset.designMode === 'true' || root.dataset.subscribed === 'true') return false;
        if (['cart', 'customers/account', 'customers/login', 'password'].includes(root.dataset.pageType)) return false;
        if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkouts?|account|challenge)(?:\/|$)/i.test(location.pathname)) return false;
        if (storageRead(claimedKey)) return false;
        const dismissed = Number(storageRead(dismissKey));
        return !dismissed || Date.now() - dismissed >= dismissDays * 86400000;
      };
      const scheduledOpen = (serverResponse) => {
        if (removed || (!serverResponse && !eligible())) return;
        const focused = document.activeElement;
        const editing = focused && (focused.matches('input, textarea, select') || focused.isContentEditable);
        if (document.visibilityState === 'hidden' || anotherDialogOpen() || (!serverResponse && editing)) {
          attempts += 1;
          if (attempts < 12) timer = setTimeout(() => scheduledOpen(serverResponse), 5000);
          return;
        }
        open();
      };
      launcher.addEventListener('click', () => { clearTimeout(timer); open(); });
      root.querySelectorAll('[data-offer-close]').forEach((button) => button.addEventListener('click', close));
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
      dialog.addEventListener('close', restore);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
      root.querySelector('[data-offer-copy]')?.addEventListener('click', async () => {
        const code = root.querySelector('[data-offer-code]');
        const status = root.querySelector('[data-offer-copy-status]');
        if (!code || !status) return;
        try {
          await navigator.clipboard.writeText(code.value);
          status.textContent = root.dataset.copySuccess;
        } catch {
          code.focus();
          code.select();
          status.textContent = root.dataset.copyFallback;
        }
      });
      form?.addEventListener('submit', (event) => {
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        clearTimeout(timer);
        if (submit) submit.disabled = true;
        if (submitLabel) submitLabel.textContent = root.dataset.savingLabel;
      });
      const resetSubmit = () => { if (submit) submit.disabled = false; if (submitLabel) submitLabel.textContent = originalSubmitLabel; };
      window.addEventListener('pageshow', resetSubmit);
      const sectionSelected = (event) => {
        if (event.detail?.sectionId === root.dataset.offerSection || event.target?.contains(root)) { clearTimeout(timer); open(); }
      };
      document.addEventListener('shopify:section:select', sectionSelected);
      const teardown = (event) => {
        if (event.detail?.sectionId !== root.dataset.offerSection && !event.target?.contains(root)) return;
        removed = true;
        clearTimeout(timer);
        if (dialog.open) { dialog.close(); restore(); }
        window.removeEventListener('pageshow', resetSubmit);
        document.removeEventListener('shopify:section:select', sectionSelected);
        document.removeEventListener('shopify:section:unload', teardown);
      };
      document.addEventListener('shopify:section:unload', teardown);
      if (success) storageWrite(claimedKey, String(Date.now()));
      if (success || errors) timer = setTimeout(() => scheduledOpen(true), 0);
      else if (eligible()) timer = setTimeout(() => scheduledOpen(false), delay);
    };
    const scan = (scope) => { if (scope.matches?.(rootSelector)) initialize(scope); scope.querySelectorAll(rootSelector).forEach(initialize); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    else scan(document);
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toilet-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  const selector = '.tlo[data-toilet-offer]';
  const mounted = new WeakMap();
const initializeSpotlight = (root) => {
  const panel = root.querySelector('[data-tlo-spotlight]');
  const timers = root.querySelectorAll('[data-tlo-spotlight-timer]');
  const copy = panel?.querySelector('[data-tlo-spotlight-copy]');
  if (!panel || !timers.length || !copy) return () => {};
  const duration = 60 * 60 * 1000;
  const key = 'sopami:offer-spotlight:v2:' + root.dataset.productHandle;
  const messages = [panel.dataset.spotlightFirst, panel.dataset.spotlightSecond];
  let state;
  try { state = JSON.parse(localStorage.getItem(key)); } catch (_) {}
  const now = Date.now();
  if (!state || !Number.isFinite(state.endsAt) || state.endsAt > now + duration || !Number.isInteger(state.index) || state.index < 0 || state.index >= messages.length) {
    state = {endsAt: now + duration, index: 0};
  }
  const persist = () => { try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) {} };
  const tick = () => {
    const current = Date.now();
    if (current >= state.endsAt) {
      const elapsed = Math.floor((current - state.endsAt) / duration) + 1;
      state.index = (state.index + elapsed) % messages.length;
      state.endsAt += elapsed * duration;
      persist();
    }
    const remaining = Math.max(0, Math.ceil((state.endsAt - current) / 1000));
    const digits = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60].map(value => String(value).padStart(2, '0')).join(':');
    timers.forEach(timer => { if (timer.textContent !== digits) timer.textContent = digits; });
    if (copy.textContent !== messages[state.index]) copy.textContent = messages[state.index];
  };
  persist();
  tick();
  panel.hidden = false;
  const interval = setInterval(tick, 1000);
  return () => clearInterval(interval);
};

  const initializeReviewBrowser = (root, listen, isDisposed) => {
    const browser = root.querySelector('[data-tlo-review-browser]');
    const grid = browser?.querySelector('[data-tlo-review-grid]');
    const controls = browser?.querySelector('[data-tlo-review-controls]');
    const previous = browser?.querySelector('[data-tlo-review-previous]');
    const next = browser?.querySelector('[data-tlo-review-next]');
    const status = browser?.querySelector('[data-tlo-review-status]');
    const range = browser?.querySelector('[data-tlo-review-range]');
    const total = Number(browser?.dataset.reviewCount);
    if (!grid || !controls || !previous || !next || !status || !range || !Number.isSafeInteger(total) || total <= 6 || total > 10000 || typeof window.fetch !== 'function') return () => {};
    let assetUrl;
    let sourceUrl;
    try {
      assetUrl = new URL(browser.dataset.reviewUrl, window.location.href);
      sourceUrl = new URL(browser.dataset.reviewSource);
      if (assetUrl.protocol !== 'https:' || assetUrl.username || assetUrl.password || assetUrl.port || assetUrl.hash || !assetUrl.pathname.endsWith('/assets/toilet-offer-reviews.json') || (assetUrl.origin !== window.location.origin && assetUrl.hostname !== 'cdn.shopify.com')) return () => {};
      if (sourceUrl.href !== 'https://shop.tiktok.com/us/pdp/1732161158868603815') return () => {};
    } catch (_) { return () => {}; }
    const text = (key, fallback) => browser.dataset[key] || fallback;
    const firstNextLabel = next.textContent;
    const initialCards = Array.from(grid.childNodes, (child) => child.cloneNode(true));
    const initialRange = range.textContent;
    let reviews = null;
    let page = 0;
    let pending = false;
    let request = null;
    let timeout = null;
    const pageCount = 1 + Math.ceil((total - 6) / 12);
    const node = (tag, className, value) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (value !== undefined) element.textContent = value;
      return element;
    };
    const validReview = (review) => {
      if (!review || !Number.isInteger(review.rating) || review.rating < 4 || review.rating > 5 || typeof review.verifiedPurchase !== 'boolean') return false;
      for (const [field, max] of [['author', 100], ['body', 5000], ['variant', 500], ['country', 100]]) {
        if (typeof review[field] !== 'string' || review[field].length > max) return false;
      }
      if (!review.author.trim() || !review.author.includes('*') || !review.variant.trim()) return false;
      return typeof review.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(review.date) && Number.isFinite(Date.parse(review.date)) && new Date(review.date).toISOString().slice(0, 10) === review.date;
    };
    const card = (review) => {
      const article = node('article', 'tlo-review-card');
      const top = node('div', 'tlo-review-top');
      const date = node('time', '', review.date);
      date.dateTime = review.date;
      top.append(node('strong', '', review.author), date);
      const rating = node('div', 'tlo-review-rating');
      const stars = node('span', 'tlo-review-stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating));
      stars.setAttribute('aria-hidden', 'true');
      rating.append(stars, node('span', '', `${review.rating} / 5`));
      const body = review.body.trim() ? node('p', 'tlo-review-body', review.body) : node('p', 'tlo-review-empty', text('reviewRatingOnly', 'Rating only'));
      const meta = node('div', 'tlo-review-meta');
      if (review.verifiedPurchase) meta.append(node('span', 'tlo-review-verified', text('reviewVerified', 'Verified purchase on TikTok Shop')));
      if (review.country) meta.append(node('span', '', review.country));
      const source = node('span', 'tlo-review-source', 'TikTok Shop');
      article.append(top, rating, body, node('p', 'tlo-review-variant', review.variant), meta, source);
      return article;
    };
    const updateControls = () => {
      previous.disabled = pending || page === 0;
      next.disabled = pending || page >= pageCount - 1;
      if (!pending) next.textContent = page === 0 ? firstNextLabel : text('reviewNext', 'Next reviews');
      grid.setAttribute('aria-busy', String(pending));
    };
    const renderPage = (targetPage) => {
      const start = targetPage === 0 ? 0 : 6 + (targetPage - 1) * 12;
      const end = Math.min(total, start + (targetPage === 0 ? 6 : 12));
      const fragment = document.createDocumentFragment();
      reviews.slice(start, end).forEach((review) => fragment.append(card(review)));
      grid.replaceChildren(fragment);
      page = targetPage;
      range.textContent = `${text('reviewShowing', 'Showing')} ${start + 1}–${end} ${text('reviewOf', 'of')} ${total}`;
      status.textContent = range.textContent;
      grid.focus({preventScroll: true});
      grid.scrollIntoView?.({block: 'start', behavior: 'auto'});
    };
    const changePage = async (targetPage) => {
      if (isDisposed() || pending || targetPage < 0 || targetPage >= pageCount) return;
      pending = true;
      updateControls();
      next.textContent = text('reviewLoading', 'Loading reviews…');
      status.textContent = text('reviewLoading', 'Loading reviews…');
      let failed = false;
      try {
        if (!reviews) {
          request = new AbortController();
          timeout = window.setTimeout(() => request?.abort(), 15000);
          const response = await window.fetch(assetUrl.href, {credentials: 'omit', headers: {Accept: 'application/json'}, signal: request.signal});
          if (!response.ok) throw new Error('Review request failed');
          const result = await response.json();
          if (isDisposed()) return;
          if (result?.version !== 1 || result.mode !== 'curated-positive' || result.sourceUrl !== sourceUrl.href || result.importedCount !== total || !Array.isArray(result.reviews) || result.reviews.length !== total || !result.reviews.every(validReview)) throw new Error('Invalid review collection');
          reviews = result.reviews;
        }
        if (!isDisposed()) renderPage(targetPage);
      } catch (_) {
        failed = true;
        if (!isDisposed()) status.textContent = text('reviewError', 'Reviews could not load. Please try again.');
      } finally {
        if (timeout !== null) window.clearTimeout(timeout);
        timeout = null;
        request = null;
        pending = false;
        if (!isDisposed()) {
          updateControls();
          if (failed) next.textContent = text('reviewRetry', 'Try again');
        }
      }
    };
    listen(previous, 'click', () => changePage(page - 1));
    listen(next, 'click', () => changePage(page + 1));
    controls.hidden = false;
    updateControls();
    return () => {
      request?.abort();
      if (timeout !== null) window.clearTimeout(timeout);
      grid.replaceChildren(...initialCards);
      grid.removeAttribute('aria-busy');
      range.textContent = initialRange;
      status.textContent = '';
      controls.hidden = true;
    };
  };
  const initialize = (root) => {
    if (mounted.has(root)) return;

    const controller = new AbortController();
    const listen = (node, type, handler, options = {}) => node?.addEventListener(type, handler, {...options, signal: controller.signal});
    const all = (query) => Array.from(root.querySelectorAll(query));
    const variantInput = root.querySelector('[data-jj-variant-select]');
    const quantityInput = root.querySelector('.jj-product-form [name="quantity"]');
    const packButtons = all('button[data-tp-option-index="1"][data-tp-option-value]');
    const stickyBars = all('[data-tlo-sticky]');
    const purchase = root.querySelector('[data-jj-add]');
    const form = root.querySelector('.jj-product-form');
    const checkoutButton = form?.querySelector('[data-tlo-checkout]');
    const formMessage = form?.querySelector('[data-jj-form-message]');
    const cartLink = form?.querySelector('[data-jj-cart-link]');
    let data = {};
    try { data = JSON.parse(root.querySelector('[data-jj-product-data]')?.textContent || '{}'); } catch (_) {}
    const variants = Array.isArray(data?.variants) ? data.variants.filter((variant) => variant && variant.id != null) : [];
    const selected = (id = variantInput?.value) => variants.find((variant) => String(variant.id) === String(id));
    let disposed = false;
    let observer = null;
    let purchaseObserver = null;
    let checkoutInFlight = false;
    let checkoutCommitted = false;
    let checkoutUncertain = false;
    const checkoutLabel = checkoutButton?.textContent || 'BUY IT NOW';
    const sameSitePath = (value, suffix) => {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || url.username || url.password || url.search || url.hash || !url.pathname.endsWith(suffix)) return '';
        return url.pathname;
      } catch (_) { return ''; }
    };
    const addUrl = sameSitePath(root.dataset.cartAddUrl, '/cart/add.js');
    const checkoutUrl = sameSitePath(root.dataset.tloCheckoutUrl, '/checkout');
    const cartUrl = sameSitePath(root.dataset.cartUrl, '/cart');
    const checkoutReady = Boolean(form && purchase && checkoutButton && addUrl && checkoutUrl && cartUrl && typeof window.fetch === 'function');
    const checkoutLocked = () => checkoutInFlight || checkoutCommitted || checkoutUncertain;
    const showPurchaseMessage = (message, error = false, showBag = false) => {
      if (formMessage) {
        formMessage.textContent = message;
        formMessage.hidden = !message;
        formMessage.classList.toggle('is-error', error);
      }
      if (cartLink) {
        if (cartUrl) cartLink.setAttribute('href', cartUrl);
        cartLink.hidden = !showBag;
      }
    };
    const updateCheckoutState = () => {
      if (!checkoutButton) return;
      checkoutButton.hidden = !checkoutReady;
      checkoutButton.disabled = !checkoutReady || checkoutLocked() || !selected()?.available || purchase?.getAttribute('aria-busy') === 'true';
      if (checkoutLocked() && purchase && !purchase.disabled) purchase.disabled = true;
    };

    const writeText = (node, value) => {
      if (!node) return;
      const text = typeof value === 'string' || typeof value === 'number' ? String(value).trim() : '';
      node.textContent = text;
      node.hidden = !text;
    };
    const setText = (query, value) => all(query).forEach((node) => writeText(node, value));

    const updatePackPrices = (current) => {
      const color = current?.options?.[0];
      packButtons.forEach((button) => {
        const candidate = color == null ? null : variants.find((variant) =>
          Array.isArray(variant.options) && String(variant.options[0]) === String(color) &&
          String(variant.options[1]) === button.dataset.tpOptionValue);
        writeText(button.querySelector('[data-tlo-pack-price]'), candidate?.price || root.dataset.tloUnavailable || 'Not available in this color');
      });
    };

    const positiveInteger = (value, fallback) => {
      const parsed = Number(value);
      return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : fallback;
    };
    const legalQuantity = (value, variant) => {
      if (!variant || !quantityInput) return null;
      const min = positiveInteger(variant.quantityMin, 1);
      const step = positiveInteger(variant.quantityIncrement, 1);
      const rawMax = positiveInteger(variant.quantityMax, Infinity);
      const max = Number.isFinite(rawMax) ? min + Math.floor((rawMax - min) / step) * step : Infinity;
      if (max < min) return null;
      const quantity = Math.max(min, Math.min(max, positiveInteger(value, min)));
      return min + Math.floor((quantity - min) / step) * step;
    };
    const updateDisplayPrice = (variant = selected()) => {
      if (!variant) return;
      const quantity = legalQuantity(quantityInput?.value, variant) || 1;
      const total = Number(variant.priceCents) * quantity;
      const compareTotal = Number(variant.compareCents) * quantity;
      const formatTotal = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.tloCurrency || 'USD'}).format(cents / 100);
      setText('[data-jj-price]', formatTotal(total));
      setText('[data-jj-compare]', variant.onSale ? formatTotal(compareTotal) : '');
      setText('[data-tlo-saving-percent]', variant.onSale ? `SAVE ${variant.savingsPercent}%` : '');
      setText('[data-tlo-saving]', variant.onSale ? `${root.dataset.tloSaveLabel} ${formatTotal(compareTotal - total)}` : '');
      setText('[data-tlo-price-caption]', root.dataset.tloPriceLabel);
      setText('[data-tlo-compare]', variant.onSale ? formatTotal(compareTotal) : '');
      setText('[data-tlo-sticky-price]', formatTotal(total));
    };
    const updateQuantityCards = (variant = selected(), normalize = false) => {
      if (normalize) {
        const quantity = legalQuantity(quantityInput?.value, variant);
        if (quantity !== null) quantityInput.value = String(quantity);
      }
      updateDisplayPrice(variant);
    };
    const normalizeOfferQuantity = () => {
      if (quantityInput) quantityInput.value = '1';
      try {
        const current = new URL(window.location.href);
        if (current.searchParams.has('tlo_qty')) {
          current.searchParams.delete('tlo_qty');
          window.history.replaceState(window.history.state, '', current);
        }
      } catch (_) {}
    };

    const synchronize = (event) => {
      if (disposed || (event && event.target !== root)) return;
      const variant = selected(event?.detail?.variant?.id ?? variantInput?.value);
      setText('[data-tlo-current-title]', variant?.supplyLabel);
      setText('[data-tlo-selected-supply]', variant?.supplyLabel);
      setText('[data-tlo-shipping]', variant?.shippingLabel);
      updatePackPrices(variant);
      updateQuantityCards(variant, true);
      updateCheckoutState();
    };

    listen(form, 'submit', async (event) => {
      const isCheckout = event.submitter === checkoutButton && checkoutButton != null;
      if (!isCheckout && !checkoutLocked()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (disposed || checkoutLocked()) return;
      if (!checkoutReady) return;
      if (purchase.getAttribute('aria-busy') === 'true') {
        showPurchaseMessage('Please wait for your current add-to-bag request to finish.');
        return;
      }
      const variant = selected();
      if (!variant?.available) {
        showPurchaseMessage('This option is sold out. Please choose another option.', true);
        return;
      }
      if (!form.reportValidity()) return;
      const quantity = legalQuantity(quantityInput?.value, variant);
      if (quantity === null || quantity !== Number(quantityInput?.value)) {
        showPurchaseMessage('Please choose a valid quantity for this option.', true);
        return;
      }
      checkoutInFlight = true;
      checkoutButton.setAttribute('aria-busy', 'true');
      checkoutButton.textContent = 'OPENING CHECKOUT…';
      showPurchaseMessage('');
      updateCheckoutState();
      let confirmedFailure = false;
      try {
        const payload = new FormData(form);
        payload.set('quantity', '1');
        const response = await window.fetch(addUrl, {method: 'POST', body: payload, credentials: 'same-origin', headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}});
        const result = await response.json();
        if (!response.ok || Number(result?.status) >= 400) {
          confirmedFailure = true;
          throw new Error(result?.description || result?.message || 'The item could not be added. Please check your selection and try again.');
        }
        const added = Array.isArray(result?.items) ? result.items : [result];
        const confirmed = added.some(item => String(item?.variant_id ?? item?.id) === String(variant.id) || String(item?.parent_relationship?.parent_id) === String(variant.id));
        if (!confirmed && !(variant.requiresComponents && added.length > 0 && added.every(item => item?.key && item?.parent_relationship))) throw new Error('Unconfirmed add response');
        checkoutCommitted = true;
        if (disposed) return;
        showPurchaseMessage('Added to your bag. Opening checkout…', false, true);
        window.location.assign(checkoutUrl);
      } catch (error) {
        if (!confirmedFailure && !checkoutCommitted) checkoutUncertain = true;
        if (disposed) return;
        if (checkoutCommitted) showPurchaseMessage('Your item was added. Open your bag to continue to checkout.', false, true);
        else if (confirmedFailure) showPurchaseMessage(error.message, true);
        else showPurchaseMessage('We could not confirm the result. Please check your bag before trying again.', true, true);
      } finally {
        checkoutInFlight = false;
        if (!disposed) {
          checkoutButton.removeAttribute('aria-busy');
          if (!checkoutCommitted) checkoutButton.textContent = checkoutLabel;
          if (!checkoutLocked()) purchase.disabled = !selected()?.available || purchase.getAttribute('aria-busy') === 'true';
          updateCheckoutState();
        }
      }
    }, {capture: true});
    listen(root, 'sopami:variantchange', synchronize);
    listen(quantityInput, 'input', () => { updateQuantityCards(); });
    listen(quantityInput, 'change', () => { updateQuantityCards(selected(), true); });

    if (checkoutReady && typeof MutationObserver === 'function') {
      purchaseObserver = new MutationObserver(() => { if (!disposed) updateCheckoutState(); });
      purchaseObserver.observe(purchase, {attributes: true, attributeFilter: ['disabled', 'aria-busy']});
    }
    stickyBars.forEach((bar) => { bar.hidden = true; });
    if (stickyBars.length) {
      // Show the sticky bar once the add-to-bag button has scrolled above the viewport. The button is looked up on
      // every check because the product form can be re-rendered after load, which left an observer on a stale node.
      let stickyTicking = false;
      const updateSticky = () => {
        stickyTicking = false;
        if (disposed) return;
        const target = root.querySelector('[data-jj-add]');
        if (!target) return;
        const hide = target.getBoundingClientRect().bottom > 0;
        stickyBars.forEach((bar) => { if (bar.hidden !== hide) bar.hidden = hide; });
      };
      const requestSticky = () => { if (!stickyTicking) { stickyTicking = true; window.requestAnimationFrame(updateSticky); } };
      listen(window, 'scroll', requestSticky, {passive: true});
      listen(window, 'resize', requestSticky);
      updateSticky();
    }

    const cleanupSpotlight = initializeSpotlight(root);
    const cleanupReviews = initializeReviewBrowser(root, listen, () => disposed);
    mounted.set(root, () => {
      disposed = true;
      cleanupReviews();
      cleanupSpotlight();
      observer?.disconnect();
      purchaseObserver?.disconnect();
      controller.abort();
      stickyBars.forEach((bar) => { bar.hidden = true; });
      mounted.delete(root);
    });

    root.classList.add('tlo-enhanced');
    all('[data-tlo-variant-id]').forEach(button => listen(button, 'click', () => {
      if (button.disabled || !variantInput) return;
      quantityInput.value = '1';
      variantInput.value = button.dataset.tloVariantId;
      variantInput.dispatchEvent(new Event('change', {bubbles:true}));

    }));
    const syncPills = () => { all('[data-tlo-variant-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tloVariantId === variantInput.value))); const current = selected(); if (current) setText('[data-tlo-current-title]', current.supplyLabel); };
    listen(root, 'sopami:variantchange', syncPills);
    syncPills();
    all('video').forEach(video => listen(video, 'play', () => all('video').forEach(other => { if (other !== video) other.pause(); })));

    normalizeOfferQuantity();
    synchronize();
  };

  const scan = (scope = document) => {
    if (scope.matches?.(selector)) initialize(scope);
    scope.querySelectorAll?.(selector).forEach(initialize);
  };
  const unload = (scope) => {
    if (scope.matches?.(selector)) mounted.get(scope)?.();
    scope.querySelectorAll?.(selector).forEach((root) => mounted.get(root)?.());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once: true});
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
